<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark :color="pages.header.back" fixed>
          <v-btn icon dark @click="fecharModal()">
            <v-icon :class="pages.header.class">close</v-icon>
          </v-btn>
          <v-toolbar-title :class="pages.header.class">Pedido</v-toolbar-title>
          <!--
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :class="pages.header.class" dark flat @click="$emit('fechar-modal')">Finalizar</v-btn>
          </v-toolbar-items>
          -->
        </v-toolbar>
        <div style="padding-top: 50px;"></div>
        <template>
            <v-subheader>
              <div class="ml-auto subheading mt-3 font-weight-bold text-xs-center">
                Total do pedido: R$ {{totalPedido.total.toFixed(2).replace(".",",")}}
              </div>
            </v-subheader>
            <v-divider></v-divider>
            <template v-for="(produto,pIndex) in cart">
              <v-card class="mb-2"> 
                  <v-card-text>
                    <div class="subheading">{{produto.nome}}</div>
                    <div class="grey--text" v-if="produto.variacao && produto.variacao!='false'">
                      <template v-for="(variacao,VarIndex) in produto.variacao.value" v-if="produto.variacao.value">
                        <span v-if="VarIndex"><br></span>{{variacao.nome}}<span v-if="variacao.valor && parseFloat(variacao.valor)>0">
                          <span v-if="variacao.val=='alt'" v-html="': R$ '+parseFloat(variacao.valor).toFixed(2).replace('.',',')"></span>
                          <span v-else-if="variacao.val=='add'" v-html="' (+ R$ '+parseFloat(variacao.valor).toFixed(2).replace('.',',')+')'"></span>
                        </span>
                      </template>
                    </div>
                    <div class="grey--text caption" v-if="produto.opcionais">
                      <template v-for="(opcional,OplIndex) in produto.opcionais">
                        <span v-if="OplIndex">, </span>{{opcional.nome}}<span v-if="opcional.valor">(R$: {{opcional.valor}})</span>
                      </template>
                    </div>
                    <v-layout>
                      <v-flex xs8 class="">
                        <div class="my-2"> R$ {{produto.subtotal.toFixed(2).replace('.',',')}}</div>
                      </v-flex>
                      <v-flex xs4 class="text-xs-right">
                        <v-item-group>
                          <v-btn color="error" icon small @click="$emit('clique-botao-remove',pIndex)" class="mx-0">
                            <v-icon>remove</v-icon>
                          </v-btn>
                          <span class="subheading mx-2 font-weight-bold">{{produto.qtd}}</span>
                          <v-btn color="success" icon small @click="$emit('clique-botao-add',pIndex)" class="mx-0">
                            <v-icon>add</v-icon>
                          </v-btn>
                        </v-item-group>
                        <span class="subheading font-weight-bold">
                          R$ {{(produto.subtotal*produto.qtd).toFixed(2).replace('.',',')}}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
              </v-card>
            </template>
        </template>
        <template v-if="!registrando">
          <div class="text-xs-center">
            <v-btn color="success" @click="$emit('fechar-modal')">
              Continuar comprando
            </v-btn>
            <div v-if="!usuario">
              <v-btn color="primary" @click="finalizarPedido">Acessar conta ou Cadastrar-se</v-btn>
              <div class="px-2">
                <v-alert color="primary" :value="true" outline>
                  Para finalizar seu pedido, acesse sua conta ou cadastre-se clicando no botão acima
                </v-alert>
              </div>
              <v-btn color="success" disabled>Finalizar pedido</v-btn>
            </div>
            <v-btn v-else color="success" @click="finalizarPedido">Finalizar pedido</v-btn>
          </div>
        </template>
        <template v-else-if="registrando">
          <div class="mt-2">
              <div class="subheading mx-2">Cupom de desconto:</div>
              <template v-if="dadosDoCupom">
                <v-card class="ma-2">
                  <v-card-actions>
                    <span v-html="'Código: '+dadosDoCupom.config.cupom" class="font-weight-bold text-uppercase"></span>
                    <v-spacer></v-spacer>
                    <v-btn flat icon small color="error" @click="desativarCupom()"><v-icon>close</v-icon></v-btn>
                  </v-card-actions>
                  <v-card-text class="pt-0">
                    <span v-if="dadosDoCupom.config.descricao && dadosDoCupom.config.descricao!=''" v-html="dadosDoCupom.config.descricao+'<br>'"></span>
                      Desconto: 
                      <span v-if="dadosDoCupom.config.tipo=='porcentagem'" v-html="dadosDoCupom.config.desconto+'%(R$ '+(totalPedido.total*parseFloat(dadosDoCupom.config.desconto)/100).toFixed(2).replace('.',',')+')'"></span>
                      <span v-if="dadosDoCupom.config.tipo=='valor'" v-html="'R$ '+parseFloat(dadosDoCupom.config.desconto).toFixed(2).replace('.',',')"></span>
                      <br>
                    <template v-if="parseInt(dadosDoCupom.config.qtdminima)>0">
                      Quantidade mínima: {{dadosDoCupom.config.qtdminima}}
                      <span v-if="parseInt(dadosDoCupom.config.qtdminima)>totalPedido.itens"><v-icon color="error font-weight-bold">close</v-icon></span>
                      <span v-else><v-icon color="success">check</v-icon></span>
                      <br>
                    </template>
                    <template v-if="parseFloat(dadosDoCupom.config.valorminimo)>0">
                      Valor Mínimo(pedido): R$ {{parseFloat(dadosDoCupom.config.valorminimo).toFixed(2).replace('.',',')}}
                      <span v-if="parseFloat(dadosDoCupom.config.valorminimo)>totalPedido.total"><v-icon color="error font-weight-bold">close</v-icon></span>
                      <span v-else><v-icon color="success">check</v-icon></span>
                      <br>
                    </template>
                    <div class="caption grey--text text-xs-center">
                      Válido até: <span v-html="dadosDoCupom.fim"></span>
                    </div>
                    <div class="caption grey--text text-xs-center" v-if="dadosDoCupom.config.limiteindividual && dadosDoCupom.config.totalUsoCliente">
                      Limite: <span v-html="dadosDoCupom.config.limiteindividual"></span>
                      <span v-if="parseInt(dadosDoCupom.config.totalUsoCliente)>0" v-html="' (você já usou x'+dadosDoCupom.config.totalUsoCliente+')'"></span>
                    </div>
                    <div class="font-weight-bold text-xs-center" v-html="'Total, após desconto: R$ '+parseFloat(totalDoPedidoAposDesconto).toFixed(2).replace('.',',')"></div>
                  </v-card-text>
                </v-card>
              </template>
              <template v-else>
                <v-layout class="mx-2">
                  <v-flex>
                    <v-text-field v-model="fieldCupom" label="Cupom" hint="Clique ao lado para verificar se o cupom informado é válido" @blur="verificarCupom()"></v-text-field>
                  </v-flex>
                  <v-flex shrink v-if="fieldCupom && fieldCupom!=''"><v-btn color="grey" outline class="ma-2" @click="verificarCupom()">Aplicar</v-btn></v-flex>
                </v-layout>
                <div v-if="errorCupom && errorCupom!=null && errorCupom!=''" class="border-error border-2 pa-2">
                  <div class="subheading font-weight-bold error--text">Erro ao aplicar cupom:</div>
                  <span v-html="errorCupom" class="error--text"></span>
                  <div class="text-xs-right">
                    <v-btn small flat color="error" outline @click="errorCupom=null">Entendi</v-btn>
                  </div>
                </div>
              </template>
          </div>
          <div class="px-2 mt-2 pb-5">  
              <span class="subheading">Dados para Entrega:</span>
              <v-flex xs12>
                <template v-if="dadosPost.entrega">
                  <template v-if="dadosPost.entrega.entrega=='true'">
                    <span class="caption">Endereço:</span> {{dadosPost.entrega.endereco}}<br>
                    <template v-if="dadosPost.entrega.entrega">
                      <span class="caption">Número:</span> {{dadosPost.entrega.numero}}
                      <span class="caption"> - Complemento:</span> {{dadosPost.entrega.complemento}}<br>
                    </template>
                    <template v-if="dadosPost.entrega.bairro">
                      <span class="caption">Bairro:</span> {{dadosPost.entrega.bairro.nome}}
                      <span v-if="dadosPost.entrega.bairro.atendido=='null'">
                        (Verificando possibilidade de atendimento. Sujeito a taxa)
                      </span>
                      <template v-else>
                        <span class="caption"><br>Taxa de Entrega: </span><strong>R$ {{parseFloat(dadosPost.entrega.bairro.taxa).toFixed(2).replace(".",",")}}</strong>
                        <!-- <span v-if="obs.entrega" v-html="obs.entrega" class="grey--text"></span> -->
                        <v-card v-if="obs.entrega">
                          <v-card-text v-if="obs.entrega.taxazeroentrega">
                            <div class="font-weight-bold">Garanta Frete grátis:</div>
                            <div v-if="obs.entrega.taxazeroentrega.qtdminima">
                              Quantidade mínima: <span class="font-weight-bold" v-html="obs.entrega.taxazeroentrega.qtdminima"></span>
                              <v-icon v-if="totalPedido.itens>=parseInt(obs.entrega.taxazeroentrega.qtdminima)" color="success">check</v-icon><v-icon v-else color="error">close</v-icon>
                            </div>
                            <div v-if="obs.entrega.taxazeroentrega.valorminimo">
                              Valor mínimo: <span class="font-weight-bold" v-html="'R$ '+parseFloat(obs.entrega.taxazeroentrega.valorminimo).toFixed(2).replace('.',',')"></span>
                              <v-icon v-if="totalDoPedidoAposDesconto>=parseFloat(obs.entrega.taxazeroentrega.valorminimo)" color="success">check</v-icon><v-icon v-else color="error">close</v-icon>
                              <template v-if="dadosDoCupom">
                                <br>* após o desconto do cupom
                              </template>
                            </div>
                          </v-card-text>
                          <v-card-text v-else v-html="obs.entrega"></v-card-text>
                        </v-card>
                        <v-alert v-if="dadosPost.entrega.bairro.estimativa" :value="true" color="warning" icon="warning" outline><span class="subheading font-weight-bold">Previsão de entrega:</span><br>
                          <template v-if="dadosPost.entrega.bairro.estimativa.mensagem">
                            <span v-html="dadosPost.entrega.bairro.estimativa.mensagem"></span>
                          </template>
                          <template v-else>
                          (* após confirmação do pagamento)<br>{{dadosPost.entrega.bairro.estimativa.diasemana}}, {{dadosPost.entrega.bairro.estimativa.datad.data.d}}/{{dadosPost.entrega.bairro.estimativa.datad.data.m}}/{{dadosPost.entrega.bairro.estimativa.datad.data.y}} ({{dadosPost.entrega.bairro.estimativa.dias}} dias)
                          </template>
                        </v-alert>
                      </template>
                    </template>
                  </template>
                  <template v-else-if="dadosPost.entrega.retirada>0">
                    <span class="caption">Retirar em:</span>
                    <br>{{dadosPost.entrega.nome}}
                    <v-alert :value="true" color="warning" icon="warning" outline v-if="dadosPost.entrega.obs && dadosPost.entrega.obs!=''">{{dadosPost.entrega.obs}}</v-alert>
                  </template>
                  <template v-else>{{dadosPost.entrega}}</template>
                  <v-btn color="error" outline @click="dadosPost.entrega=null" block small> <v-icon>close</v-icon> <span>Alterar forma de entrega</span></v-btn>
                  <template v-if="dadosPost.entrega.calendar">
                    <div class="subheading font-weight-bold">Data da entrega</div>
                    <div>* Selecione abaixo a data desejada para receber o pedido.</div>
                    <table class="calendar">
                      <template v-for="line in dadosPost.entrega.calendar.lines">
                        <template v-if="line.type=='title'">
                          <tr><th v-html="line.text" colspan="7" class="text-xs-center font-weight-bold grey lighten-2 py-1"></th></tr>
                          <tr>
                            <td class="font-weight-bold grey--text text-xs-center" v-html="'D'"></td>
                            <td class="font-weight-bold grey--text text-xs-center" v-html="'S'"></td>
                            <td class="font-weight-bold grey--text text-xs-center" v-html="'T'"></td>
                            <td class="font-weight-bold grey--text text-xs-center" v-html="'Q'"></td>
                            <td class="font-weight-bold grey--text text-xs-center" v-html="'Q'"></td>
                            <td class="font-weight-bold grey--text text-xs-center" v-html="'S'"></td>
                            <td class="font-weight-bold grey--text text-xs-center" v-html="'S'"></td>
                          </tr>
                        </template>
                        <template v-else-if="line.type=='days'">
                          <template v-for="days in line.days">
                            <tr>
                              <template v-for="day in days">
                                <td>
                                  <template v-if="day.active">
                                    <v-btn v-if="dadosPost.entrega.data_cliente && dadosPost.entrega.data_cliente==day.value" small block v-html="day.text" color="success" @click="dadosPost.entrega.data_cliente = ''"></v-btn>
                                    <v-btn v-else small block v-html="day.text" outline color="success" @click="dadosPost.entrega.data_cliente = day.value"></v-btn>
                                  </template>
                                  <v-btn v-else small block disabled flat v-html="day.text" color="success"></v-btn>
                                </td>
                              </template>
                            </tr>
                          </template>
                        </template>
                        <td v-else colspan="7">{{line}}</td>
                      </template>
                    </table>
                  </template>
                </template>
                <template v-else>
                  <div class="border-primary border-2 pa-2">
                    <span class="caption primary--text font-weight-bold">* Selecione abaixo a forma de entrega:</span>
                    <v-alert color="error" :value="true" outline v-if="enderecosEmpty">
                      <span class="font-weight-bold">Você ainda não possui um endereço cadastrado.</span>
                      <ul>
                        <li>Clique no botão abaixo;</li>
                        <li>Cadastre seu endereço; e</li>
                        <li>Selecione o endereço para entrega na caixa de seleção abaixo.</li>
                      </ul>
                    </v-alert>
                    <v-layout>
                      <v-flex shrink class="pt-1 pr-1"><v-icon color="primary">error</v-icon></v-flex>
                      <v-flex>
                        <v-select v-model="dadosPost.entrega"
                          :items="enderecosParaEntrega"
                          :label="'Forma de entrega:'"
                          class="pt-0 mt-0"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                    <v-btn v-if="!sementrega" color="primary" class="mt-0" @click="$emit('open-cad-endereco')" block> <v-icon>add</v-icon> <span>Cadastrar Novo Endereço</span></v-btn>
                  </div>
                </template>
              </v-flex>
              <v-card v-if="opcoes && ((dadosPost.entrega && dadosPost.entrega.entrega=='true' && opcoes.entrega && opcoes.entrega.length>0)|| (dadosPost.entrega && parseInt(dadosPost.entrega.retirada)>0 && opcoes.retirada))" class="elevation-4 mt-2">
                <v-card-text class="font-weight-bold pb-0">Opções Adicionais:</v-card-text>
                <v-card-text class="pt-0">
                  <template v-if="dadosPost.entrega && dadosPost.entrega.entrega=='true' && opcoes.entrega">
                    <!--
                    <template :class="borderopcoes" v-for="(grupos,grpIndex) in opcoes.entrega" v-if="opcoes.entrega.length>0">
                      <v-select v-if="grupos.obrigatorio=='true'" :label="'* '+grupos.nome" :items="grupos.opcoes" v-model="dadosPost.opcoesDeEntrega[grpIndex]"></v-select>
                      <v-select v-else :label="grupos.nome" :items="grupos.opcoes" v-model="dadosPost.opcoesDeEntrega[grpIndex]"></v-select>
                    </template>
                    -->
                    <template :class="borderopcoes" v-for="(grupos,grpIndex) in opcoes.entrega" v-if="opcoes.entrega.length>0">
                      <div v-if="grupos.obrigatorio=='true'" :class="borderopcoes">
                        <v-layout wrap>
                          <v-flex v-if="registro_erro.code == 'camposobrigatorios'" shrink class="pt-4"><v-icon color="error">arrow_right_alt</v-icon></v-flex>
                          <v-flex>
                            <v-select :label="'* '+grupos.nome" :items="grupos.opcoes" v-model="dadosPost.opcoesDeEntrega[grpIndex]"></v-select>
                          </v-flex>
                        </v-layout>
                      </div>
                      <template v-else>
                        <v-select :label="grupos.nome" :items="grupos.opcoes" v-model="dadosPost.opcoesDeEntrega[grpIndex]"></v-select>
                      </template>
                    </template>
                  </template>
                  <template v-else-if="dadosPost.entrega && parseInt(dadosPost.entrega.retirada)>0 && opcoes.retirada">
                    <template v-for="(grupos,grpIndex) in opcoes.retirada" v-if="opcoes.retirada.length>0">
                      <v-select v-if="grupos.obrigatorio=='true'" :label="'* '+grupos.nome" :items="grupos.opcoes" v-model="dadosPost.opcoesDeRetirada[grpIndex]"></v-select>
                      <v-select v-else :label="grupos.nome" :items="grupos.opcoes" v-model="dadosPost.opcoesDeRetirada[grpIndex]"></v-select>
                    </template>
                  </template>
                </v-card-text>
              </v-card>
              <v-flex xs12>
                <v-textarea
                  color="teal"
                  rows="3"
                  v-model="dadosPost.observacoes"
                >
                  <template v-slot:label>
                    <div>
                      Observações
                    </div>
                  </template>
                </v-textarea>
              </v-flex>
              <div v-if="registro_erro.msg && registro_erro.msg!=null && registro_erro.msg!=''" class="border-error border-2 pa-2">
                <div class="subheading font-weight-bold error--text">Erro ao registrar:</div>
                <span v-html="registro_erro.msg" class="error--text"></span>
                <div class="text-xs-right">
                  <v-btn small flat color="error" outline @click="registro_erro.msg=null,registro_erro.code=null">Entendi</v-btn>
                </div>
              </div>
              <div class="text-xs-center">
                <v-btn color="success" @click="registrarPedido"
                  :loading="registrandopedido"
                  :disabled="registrandopedido"
                  >
                  Finalizar Pedido
                </v-btn>
              </div>
          </div>
        </template>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  import jquery from 'jquery';
  
  export default {
    props:['baseUrlApi','dialog','cart','totalPedido','usuario','pages'],
    data () {
      return {
        //dialog: false,
        loader: null,
        registro_erro: {msg: null,code: null},
        registrandopedido: false,
        notifications: false,
        sound: true,
        widgets: false,
        sementrega: false,
        dadosPost: {
          entrega: null,
          retirada: null,
          endereco: "",
          observacoes: "",
          cupom: null,
          opcoesDeEntrega: [],
          opcoesDeRetirada: []
        },
        obs: {entrega: null},
        opcoes: null,
        registrando: null,
        enderecosParaEntrega: [],
        fieldCupom: null,
        errorCupom: null,
        dadosDoCupom: null,
        enderecosEmpty: false
      }
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      }
    },
    methods:{
      fecharModal(){
        this.registrando = null;
        this.$emit('fechar-modal');
      },
      finalizarPedido(){
        //console.log("finalizar pedido");
        if(!this.usuario){
          this.$emit('acesso-de-usuario');
        }else{
          //console.log(this.baseUrlApi+'cadastroDeUsuario/getEnderecos');
          jquery.get(this.baseUrlApi+'cadastroDeUsuario/getEnderecos')
            .then(response =>(this.resposta_finalizarPedido(response)));
        }
      },
      resposta_finalizarPedido(response){
        if(!response.situacao && response.erro && response.erro=='loginno'){
          this.$emit('erro-loginno');
          return;
        }
        if(response.dados.sementrega){
          this.sementrega = true;
        }
        this.registrando = true;
        this.enderecosParaEntrega = response.dados.enderecos;
        if(response.dados.obs.entrega){
          this.obs.entrega = response.dados.obs.entrega;
        }
        if(response.dados.opcoes){
          this.opcoes = response.dados.opcoes;
        }
        if(response.dados.enderecosEmpty){
          this.enderecosEmpty = response.dados.enderecosEmpty;
        }
        //opcoesementrega
      },
      registrarPedido(){
        if(!this.dadosPost.entrega){
          this.registro_erro.msg = 'Para registrar seu pedido, você precisa selecionar a forma de entrega no campo a cima.';
          return;
        }
        if((this.dadosPost.entrega.calendar && this.dadosPost.entrega.data_cliente=='')){
          this.registro_erro.msg = 'Para registrar seu pedido, informe uma data para entrega.';
          return;
        }
        if(this.dadosPost.entrega && this.dadosPost.entrega.entrega=='true' && this.opcoes && this.opcoes.entrega && this.opcoes.entrega.length>0){
          for(let i=0;i<this.opcoes.entrega.length;i++){
            //console.log(this.opcoes.entrega[i]);
            if(this.opcoes.entrega[i].obrigatorio=="true"){
              if(!this.dadosPost.opcoesDeEntrega[i] || this.dadosPost.opcoesDeEntrega[i]==''){
                this.registro_erro.msg = 'Campos Obrigatórios não preenchidos<br>(Marcados com asterisco "*")';
                this.registro_erro.code = 'camposobrigatorios';
                return;
              }else{
                //console.log('opção');
                //console.log(this.dadosPost.opcoesDeEntrega[i]);
              }
            }
          }
        }else if(this.dadosPost.entrega && parseInt(this.dadosPost.entrega.retirada)>0 && this.opcoes && this.opcoes.retirada && this.opcoes.retirada.length>0){
          for(let i=0;i<this.opcoes.retirada.length;i++){
            //console.log(this.opcoes.retirada[i]);
            if(this.opcoes.retirada[i].obrigatorio=="true"){
              if(!this.dadosPost.opcoesDeRetirada[i] || this.dadosPost.opcoesDeRetirada[i]==''){
                this.registro_erro.msg = 'Campos Obrigatórios não preenchidos<br>(Marcados com asterisco "*")';
                return;
              }else{
                //console.log('opção');
                //console.log(this.dadosPost.opcoesDeRetirada[i]);
              }
            }
          }
        }
        this.loader = 'registrandopedido';
        this.$emit('registrar-pedido',this.dadosPost);
      },
      verificarCupom(){
        //testep
        //this.fieldCupom
        if(this.fieldCupom==''){
          return;
        }
        jquery.get(this.baseUrlApi+"public_negocios/verificarCupom/"+this.fieldCupom).then(response => (this.resposta_verificarCupom(response)));
      },
      resposta_verificarCupom(response){
        if(response.situacao == true){
          //console.log(response.dados);
          //console.log(response.dados.cupom.config);
          this.dadosDoCupom = response.dados.cupom;
          this.dadosPost.cupom = response.dados.cupom.id;
          this.$emit("snackbar-alert","Cupom aplicado","success");
        }else{
          //console.log(response);
          this.$emit("snackbar-alert",response.mensagem,"error");
          this.errorCupom = response.mensagem;
        }
      },
      desativarCupom(){
        this.dadosDoCupom = null;
        this.dadosPost.cupom = null;
      }
    },
    computed:{
      totalDoPedidoAposDesconto(){
        var total = this.totalPedido.total;
        if(this.dadosDoCupom && this.dadosDoCupom!=null){
          if(parseInt(this.dadosDoCupom.config.qtdminima)>this.totalPedido.itens){
            return total;
          }
          if(parseFloat(this.dadosDoCupom.config.valorminimo)>this.totalPedido.total){
            return total;
          }
          if(this.dadosDoCupom.config.tipo=="valor"){
            total = total - parseFloat(this.dadosDoCupom.config.desconto);
          }else if(this.dadosDoCupom.config.tipo=="porcentagem"){
            total = total - (total*parseFloat(this.dadosDoCupom.config.desconto)/100);
          }
        }
        return total;
      },
      borderopcoes(){
        if(this.registro_erro.code == 'camposobrigatorios'){
          return 'border-error border-2 my-2 px-1';
        }
        return '';
      }
    }
  }
</script>
<style>
  .border-1{
    border-style: solid;
    border-width: 1px;
  }
  .border-2{
    border-style: solid;
    border-width: 2px;
  }
  .border-error{
    border-color:#ff5252;
  }
  .border-primary{
    border-color:#1876D2;
  }
  .calendar{
    width: 100%;
    border: 2px solid #ccc;
  }
  .calendar tr td,.calendar tr th{
    width: 14.2857142%;
  }
  .calendar tr td button{
    max-width: 100%!important;
    min-width: 10px!important;
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>